<template>
<div class="chapter">
<div class="inner_page">
<div>
<p class="ct" id="toc_marker-7"><a href="#/This_Isn't_A_Game2#Contents-A">Monday</a></p>
<p class="fp">The DA’s grimace was a cross between getting kicked in the groin and walking in on his wife and two other men. More than once he lowered his head and said, “We wish this video had been made available at the outset.” </p>
<p class="body">In a separate press conference, Andrew Marvel’s ambulance-chaser described how he was working at home Saturday morning when his doorbell rang. He opened the door and found a padded envelope containing a DVD. After watching it, he immediately called the district attorney and Judge Newman.</p>
<p class="body">The ABC affiliate in Burlington received its copy of the DVD later in the day.</p>
<p class="body">In the video, Andrew Marvel lay on a motel bed, asleep or unconscious, wearing nothing but underwear. The mirror above the dresser reflected the TV screen in front of the bed.</p>
<p class="body">The backwards numbers and letters spelled out, “Revere Motel. Welcome. Press 9 to select movies.” Beneath that, “6/24, 10:13:06 PM, 10:13:07 PM, 10:13:08 PM…”</p>
<p class="body">The camera panned up to the window, keeping Andrew and the TV reflection in frame. On the other side of the street, the Lilly’s Tavern sign said, “Tonight only, the Seahorses.”</p>
<p class="body">By the time ABC aired the video, investigators had identified the location as room 208 of the Revere Motel in Manchester, New Hampshire, approximately three hours from Greensboro.</p>
<p class="body">The 911 call was made from the Marvel house at 10:07 p.m. The police found Audrey dead at 10:24.</p>
<p class="body">The State of Vermont dropped all charges against Andrew Marvel.</p>
<p class="body">Someone had ripped Jackson off. He didn’t hold it against them. He held it against himself. But before VegasVegas paid out a hundred thousand he had to find answers to a few questions:</p>
<p class="body">Was Andrew Marvel the mastermind or the prop in a bizarre betting scheme? Was Cass Gallaway a murderer, accomplice, unwitting bettor for someone who didn’t want his name on the account, or guy with a strange and lucky hunch?</p>
<p class="body">Was this Jackson’s comeuppance? If so, for what—callousness or stupidity?</p>
<p class="body">He took a flight from San Jose to Houston and now sat at a United gate waiting for his flight to Burlington, Vermont.</p>
<p class="body">CNN had the press conferences on loop.</p>
<p class="body">“Digital experts examined the video thoroughly. They’ve given me their assurance it hasn’t been manipulated in any way. We wish this video had been made public at the outset. Withholding it for this length of time, aside from the pain it caused Mr. Marvel to endure, has made the apprehension of the actual killer that much more difficult.”</p>
<p class="body">A business traveler next to Jackson mimicked the DA. “‘Aside from what it caused Mr. Marvel to endure.’ Say what you’re really thinking. ‘Mr. Marvel made us look like jackasses. He made us think he did it so we arrested him, not the killer he hired.’”</p>
<p class="body">“You think he framed himself?” Jackson said.</p>
<p class="body">“If someone else framed him, why give him an alibi?”</p>
<p class="body">The DA was wrapping up. “I’m confident our fine and dedicated police force will soon develop new leads.”</p>
<p class="body">“Messed up.” The business traveler shook his head.</p>
<p class="body">Jackson would have said “fucked up,” but why quibble?</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// This_Isnt_A_Game-6.vue?393ac396